<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <!-- Login Form -->
    <transition name="fade">
      <div
        v-if="showLogin"
        class="login-page"
      >

        <div class="container">
          <div class="columns">
            <div class="column is-half is-offset-one-quarter">
              <h3 class="mb-4 block">Entre usando suas credenciais de cliente paciente ou profissional</h3>
              <ValidationObserver
                ref="loginFormObserver"
                tag="form"
                @submit.prevent="validateLoginBeforeSubmit()"
              >
                <!-- Email -->
                <validation-provider
                  rules="required|email"
                  v-slot="{ errors }"
                  name="Email"
                >
                  <b-field
                    label="Login"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model="loginForm.email"
                      class="input-login"
                      name="email"
                    />
                  </b-field>
                </validation-provider>

                <!-- Senha -->
                <validation-provider
                  rules="required"
                  v-slot="{ errors }"
                  name="Senha"
                >
                  <b-field
                    label="Senha"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model="loginForm.password"
                      class="input-senha"
                      type="password"
                      name="password"
                    />
                  </b-field>
                  <a
                    class="uppercase text-center my-4 block"
                    @click="togglePasswordReset"
                  >Esqueci Minha Senha</a>
                </validation-provider>

                <!-- Botões -->
                <div class="login-buttons mb-0 mt-8 block">
                  <b-button
                    class="is-primary is-fullwidth"
                    native-type="submit"
                  >
                    Login
                  </b-button>
                  <div class="text-center uppercase my-4 block">
                    <span class="text-xs">Não possui uma conta?</span> <br />

                    <b-button
                      class="is-light is-fullwidth my-4 block"
                      @click="toggleSignup"
                    >
                      Cadastre-se
                    </b-button>
                  </div>
                  <br />

                </div>
              </ValidationObserver>

              <transition name="fade">
                <div
                  v-if="errorMsg !== ''"
                  class="error-msg"
                >
                  <p>{{ errorMsg }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Signup Form -->
    <transition name="fade">
      <div
        v-if="showSignup"
        class="signup-page"
      >
        <div class="container">
          <div class="columns">
            <div class="column is-half is-offset-one-quarter">
              <h2 class="is-full">
                Tipo de Cadastro
              </h2>
              <ValidationObserver
                ref="signupFormObserver"
                tag="form"
                @submit.prevent="validateSignupBeforeSubmit()"
              >
                <!-- Tipo de Conta -->
                <span class="account-type">
                  <b-radio
                    v-model="signupForm.userType"
                    name="name"
                    size="is-small"
                    native-value="professional"
                  >
                    Profissional
                  </b-radio>
                  <b-radio
                    v-model="signupForm.userType"
                    name="name"
                    size="is-small"
                    native-value="patient"
                  >
                    Cliente
                  </b-radio>
                </span>

                <!-- Nome -->
                <validation-provider
                  rules="required"
                  v-slot="{ errors }"
                  name="Nome"
                >
                  <b-field
                    label="Nome"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="signupForm.name"
                      class="input-name"
                    />
                  </b-field>
                </validation-provider>

                <!-- Sobrenome -->
                <validation-provider
                  rules="required"
                  v-slot="{ errors }"
                  name="Sobrenome"
                >
                  <b-field
                    label="Sobrenome"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="signupForm.lastName"
                      class="input-name"
                    />
                  </b-field>
                </validation-provider>

                <!-- Email -->
                <validation-provider
                  rules="required|email"
                  v-slot="{ errors }"
                  name="Email"
                >
                  <b-field
                    label="Email"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="signupForm.email"
                      class="input-email"
                      type="email"
                    />
                  </b-field>
                </validation-provider>

                <!-- Senha -->
                <validation-provider
                  rules="required"
                  v-slot="{ errors }"
                  name="Senha"
                >
                  <b-field
                    label="Senha"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="signupForm.password"
                      class="input-password"
                      type="password"
                    />
                  </b-field>
                </validation-provider>

                <!-- Confirmação de Senha -->
                <validation-provider
                  rules="required|password:Senha"
                  v-slot="{ errors }"
                  name="Confirmação de Senha"
                >
                  <b-field
                    label="Confirmação de Senha"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="signupForm.passwordConfirmation"
                      class="input-password-confirmation"
                      type="password"
                    />
                  </b-field>
                </validation-provider>

                <!-- Botões -->
                <div class="login-buttons">
                  <b-button
                    type="is-primary is-fullwidth signup"
                    native-type="submit"
                  >
                    Cadastrar
                  </b-button>
                  <b-button
                    type="is-fullwidth signup"
                    @click="toggleLogin"
                  >
                    Voltar ao Login
                  </b-button>
                </div>
              </ValidationObserver>
              <transition name="fade">
                <div
                  v-if="errorMsg !== ''"
                  class="error-msg"
                >
                  <p>{{ errorMsg }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Password Reset Form -->
    <transition name="fade">
      <div
        v-if="showPasswordReset"
        class="password-reset-page"
      >
        <div class="container p-4">
          <div class="columns">
            <div class="column is-half is-offset-one-quarter">
              <h1>
                Recuperar Senha
              </h1>
              <ValidationObserver
                v-if="!isRecoverSent"
                ref="recoverFormObserver"
                tag="form"
                @submit.prevent="validateRecoverBeforeSubmit()"
              >
                <!-- Email -->
                <validation-provider
                  rules="required|email"
                  v-slot="{ errors }"
                  name="Email"
                >
                  <b-field
                    label="Email usado no cadastro"
                    :type="{'is-danger': errors[0]}"
                    :message="errors[0]"
                  >
                    <b-input
                      v-model.trim="recoverEmail"
                      class="input-email"
                      type="email"
                    />
                  </b-field>
                </validation-provider>

                <!-- Botões -->
                <div class="login-buttons">
                  <b-button
                    type="is-primary is-fullwidth signup"
                    native-type="submit"
                  >
                    Recuperar Senha
                  </b-button>
                  <b-button
                    type="is-fullwidth signup"
                    @click="toggleLogin"
                  >
                    Voltar ao Login
                  </b-button>
                </div>
              </ValidationObserver>
              <div
                v-else
                class="mt-16"
              >
                <b-message
                  title="Email de recuperação eviado com sucesso!"
                  type="is-success"
                  has-icon
                  aria-close-label="Close message"
                  :closable="false"
                >
                  Um email de recuperação foi enviado para o endereço informado.
                  Verifique sua caixa de entrada e utilize o link enviado para redefinir sua senha.
                </b-message>
                <div class="login-buttons">
                  <b-button
                    type="is-fullwidth signup"
                    @click="toggleLogin"
                  >
                    Voltar ao Login
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import { usersCollection, auth } from '../firebaseConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

const DEBUG = process.env.NODE_ENV === 'development'

export default {
  components: {
    ValidationProvider, ValidationObserver
  },
  name: 'Login',
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        userType: 'professional',
        name: '',
        lastName: '',
        email: '',
        password: '',
        passwordConfirmation: ''
      },
      showSignup: false,
      showLogin: true,
      showPasswordReset: false,
      performingRequest: false,
      errorMsg: '',
      recoverEmail: '',
      isRecoverSent: false
    }
  },

  methods: {
    toggleSignup () {
      this.showSignup = !this.showSignup
      this.errorMsg = ''

      if (this.showSignup) {
        this.showLogin = false
        this.showPasswordReset = false
      }
    },
    toggleLogin () {
      this.showLogin = !this.showLogin
      this.errorMsg = ''

      if (this.showLogin) {
        this.showSignup = false
        this.showPasswordReset = false
      }
    },
    togglePasswordReset () {
      this.showPasswordReset = !this.showPasswordReset
      this.errorMsg = ''

      if (this.showPasswordReset) {
        this.showSignup = false
        this.showLogin = false
      }
    },
    async validateSignupBeforeSubmit () {
      const isValid = await this.$refs.signupFormObserver.validate()

      isValid
        ? this.signup()
        : this.$toasted.error('Não foi possível completar o cadastro. Verifique os dados e tente novamente')
    },
    async validateRecoverBeforeSubmit () {
      const isValid = await this.$refs.recoverFormObserver.validate()

      isValid
        ? this.recover()
        : this.$toasted.error('Não foi possível enviar um email de recuperaçao de senha. Verifique os dados e tente novamente')
    },
    async validateLoginBeforeSubmit () {
      const isValid = await this.$refs.loginFormObserver.validate()

      isValid
        ? this.login()
        : this.$toasted.error('Não foi possível realizar o login. Verifique os dados e tente novamente')
    },
    login () {
      this.performingRequest = true

      const { password, email } = this.loginForm

      auth
        .signInWithEmailAndPassword(email, password)
        .then(async user => {
          this.$store.commit('setCurrentUser', user.user)

          await this.$store.dispatch('fetchUserProfile')

          if (this.$store.state.userProfile.userType === 'professional') {
            await this.$store.dispatch('fetchProfessionalProfile')
          }

          this.performingRequest = false
          this.$router.push('/dashboard')
        })
        .catch(err => {
          console.log(err)
          this.performingRequest = false
          this.$toasted.error(err.message)
        })
    },
    signup () {
      this.performingRequest = true

      const { password, email, name, lastName, userType } = this.signupForm

      auth.createUserWithEmailAndPassword(email, password)
        .then(({ user }) => {
          this.$store.commit('setCurrentUser', user)

          // create user obj
          usersCollection
            .doc(user.uid)
            .set({
              name,
              lastName,
              email,
              userType,
              isPremium: false
            })
            .then(() => {
              this.$store.dispatch('fetchUserProfile')
              this.performingRequest = false
              this.$router.push('/dashboard')
            })
            .catch(err => {
              console.error(err)
              this.performingRequest = false
            })
        })
        .catch(err => {
          console.error(err)
          this.$toasted.error(err.message)
          this.performingRequest = false
        })
    },
    async recover () {
      try {
        this.performingRequest = true
        await auth.sendPasswordResetEmail(this.recoverEmail)
        this.$toasted.success('Email de recuperação enviado com sucesso!')
        this.isRecoverSent = true
      } catch (error) {
        this.$toasted.error('Um error ocorreu. Tente novamente mais tarde')
        DEBUG && console.error(error)
      } finally {
        this.performingRequest = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
